var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<span ng-class=\"{'label-success': vm.isRegelsatzActive(), 'label-default': vm.regelsatz.status_obj.kf_id === vm.FoerderangebotstatusUUIDs.freigegeben &amp;&amp; !vm.isRegelsatzActive(), 'label-danger': vm.regelsatz.status_obj.kf_id === vm.FoerderangebotstatusUUIDs.deaktiviert, 'label-info': vm.regelsatz.status_obj.kf_id === vm.FoerderangebotstatusUUIDs.inBearbeitung, 'label-warning': vm.regelsatz.status_obj.kf_id === vm.FoerderangebotstatusUUIDs.abgeschlossen}\" class=\"label\">{{ vm.getRegelsatzStatusLabelKbez() }}</span>");;return buf.join("");
}